import { createFileRoute } from "@tanstack/react-router";
import { BaggersLayout } from "#/features/baggers/components/baggers-layout";

export const Route = createFileRoute("/_app/baggers")({
	component: BaggersLayout,
});
